export const EQUIPMENT_CATALOG = [
  'Kule Vinç',
  'Mobil Vinç',
  'Ekskavatör',
  'Beko Loder',
  'Greyder',
  'Silindir',
  'Forklift',
  'Beton Pompası',
  'JCB',
  'Mini Yükleyici',
  'Jeneratör',
  'Kompresör',
  'Su Tankeri',
  'Kamyon',
  'Damperli Kamyon',
  'İskele Sistemi',
  'Kalıp Sistemi',
  'Sehpa ve Kiriş',
  'Demir Kesme Makinesi',
  'Demir Bükme Makinesi',
  'Kaynak Makinesi',
  'Lazer Seviye',
  'Total Station',
  'Diğer',
];

export const MATERIAL_CATALOG = [
  'Çimento',
  'Demir',
  'Hazır Beton',
  'Agrega',
  'Kum',
  'Çakıl',
  'Tuğla',
  'Gazbeton',
  'Kalıp Yağı',
  'Kalıp Kontraplak',
  'Alçı',
  'Sıva Harcı',
  'Seramik',
  'Boya',
  'Su Yalıtım Malzemesi',
  'Isı Yalıtım Malzemesi',
  'Elektrik Kablosu',
  'Boru',
  'Armatür',
  'Vida ve Dübel',
  'Çelik Profil',
  'Ahşap Kereste',
  'Membran',
  'Diğer',
];

export const UNIT_OPTIONS = ['Adet', 'm', 'm2', 'm3', 'kg', 'ton', 'paket', 'set', 'lt', 'Diğer'];
